.substructureSize {
  display: flex;
  gap: 1em;
  align-items: center;
}

.substructureSize > span {
  font-size: small;
}

.substructureSize input {
  width: 135px;
}
